import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  zones: [],
  allZones: [],
  totalPages: 0,
  totalRecords: 0,
  zone: null,
  errorStatus: null,
};
const getters = {
  getApiLoad_114: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_Zones(state, zones) {
    state.zones = zones.items;
    state.totalPages = zones.totalPages;
    state.totalRecords = zones?.totalRecords ?? 0;
  },
  SET_AllZones(state, zones) {
    state.allZones = zones;
  },
  SET_Zone(state, zone) {
    state.zone = zone;
  },
};
const actions = {
  errorZone({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllZones({ commit, dispatch, rootState }) {
    return apiClient
      .get('/Zones/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllZones', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorZone', error);
      });
  },
  getAllZonesWithCityId({ commit, dispatch, rootState }, cityId) {
    return apiClient
      .get('/Zones/All?CityId=' + cityId, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllZones', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorZone', error);
      });
  },
  addZone({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Zones', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorZone', error);
      });
  },
  getZone({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/Zones/ById?zoneId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_Zone', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorZone', error);
      });
  },
  editZone({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/Zones/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorZone', error);
      });
  },
  deleteZone({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/Zones/Remove?zoneId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorZone', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
